exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".order-item-type-icon.fa-long-arrow-alt-right{color:green}.order-item-type-icon.fa-long-arrow-alt-left{color:red}\n", "", {"version":3,"sources":["D:/a/1/s/ContainerWeb.WebApp/src/components/serviceOrders/D:/a/1/s/ContainerWeb.WebApp/src/components/serviceOrders/D:/a/1/s/ContainerWeb.WebApp/src/components/serviceOrders/order-item-type-icon.scss"],"names":[],"mappings":"AAAA,8CAEI,WAAY,CAFhB,6CAMI,SAAU,CAAA","file":"order-item-type-icon.scss","sourcesContent":[".order-item-type-icon {\r\n  &.fa-long-arrow-alt-right {\r\n    color: green;\r\n  }\r\n  \r\n  &.fa-long-arrow-alt-left {\r\n    color: red;\r\n  }\r\n}"],"sourceRoot":""}]);

// exports
